import { render, staticRenderFns } from "./TerminalesTable.vue?vue&type=template&id=0f986157&scoped=true&"
import script from "./TerminalesTable.vue?vue&type=script&lang=js&"
export * from "./TerminalesTable.vue?vue&type=script&lang=js&"
import style0 from "./TerminalesTable.vue?vue&type=style&index=0&id=0f986157&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f986157",
  null
  
)

export default component.exports